import script from "./searchGroupDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./searchGroupDialog.vue?vue&type=script&setup=true&lang=js"

import "./searchGroupDialog.vue?vue&type=style&index=0&id=fb27003c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb27003c"]])

export default __exports__